import React, { useEffect, useId, useRef, useState } from 'react';
import { ChevronDown, Info } from 'lucide-react';

function InfoTooltip({ text }) {
  return (
    <span className="info-tooltip-wrapper">
      <Info size={13} className="info-tooltip-icon" />
      <span className="info-tooltip-bubble">{text}</span>
    </span>
  );
}

function CustomDropdown({ label, value, options, onChange, placeholder = 'Select', tooltip }) {
  const [open, setOpen] = useState(false);
  const dropdownId = useId();
  const rootRef = useRef(null);
  const triggerId = `${dropdownId}-trigger`;
  const menuId = `${dropdownId}-menu`;

  useEffect(() => {
    const onClickOutside = (event) => {
      if (rootRef.current && !rootRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    };

    document.addEventListener('mousedown', onClickOutside);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onClickOutside);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, []);

  const selected = options.find(opt => opt.value === value);

  return (
    <div className="custom-dropdown" ref={rootRef}>
      {label && (
        <label className="input-label">
          {label}
          {tooltip && <InfoTooltip text={tooltip} />}
        </label>
      )}
      <button
        id={triggerId}
        type="button"
        className="dropdown-trigger"
        onClick={() => setOpen(prev => !prev)}
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-controls={menuId}
      >
        <span className={selected ? 'dropdown-value' : 'dropdown-placeholder'}>
          {selected ? selected.label : placeholder}
        </span>
        <ChevronDown size={16} className={open ? 'dropdown-icon open' : 'dropdown-icon'} />
      </button>
      {open && (
        <div className="dropdown-menu" id={menuId} role="listbox" aria-labelledby={triggerId}>
          {options.map(option => (
            <button
              key={option.value}
              type="button"
              className={value === option.value ? 'dropdown-item selected' : 'dropdown-item'}
              role="option"
              aria-selected={value === option.value}
              onClick={() => {
                onChange(option.value);
                setOpen(false);
              }}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default CustomDropdown;
